import React, { useState } from 'react';
import styles from './ImagePopup.module.css';

type Props = {
  url: string;
  alt: string;
  setImageContent?: any;
};

const ImagePopup = ({ url, alt, setImageContent }: Props) => {
  const [isImageClosing, setIsImageClosing] = useState(false);

  const handleClose = () => {
    setIsImageClosing(true);
    setTimeout(() => {
      setImageContent(undefined);
    }, 245);
  };

  return (
    <div
      onClick={handleClose}
      className={`${styles.imageContainer} ${
        isImageClosing ? styles.exit : null
      }`}
    >
      <img className={styles.image} src={url} alt={alt} />
    </div>
  );
};

export default ImagePopup;
